var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('g', [_c('path', {
    attrs: {
      "d": "M12 22C6.48 22 2 17.52 2 12S6.48 2 12 2s10 4.48 10 10-4.48 10-10 10Z",
      "opacity": ".4"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M15 11.75c-.72 0-1.25-.74-1.25-1.75s.53-1.75 1.25-1.75 1.25.74 1.25 1.75-.53 1.75-1.25 1.75ZM10.25 10c0-1.01-.53-1.75-1.25-1.75S7.75 8.99 7.75 10s.53 1.75 1.25 1.75 1.25-.74 1.25-1.75Zm6.2 7.6c.33-.25.4-.72.15-1.05a5.774 5.774 0 0 0-4.59-2.3c-1.79 0-3.49.84-4.6 2.3a.749.749 0 1 0 1.19.91c.82-1.08 2.06-1.7 3.4-1.7 1.34 0 2.59.64 3.39 1.7.15.2.37.3.6.3.16 0 .31-.05.45-.15l.01-.01Z",
      "stroke": "#000000",
      "stroke-width": ".3",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }